// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.92.0-beta.384fd2e11',
  revision: '384fd2e11',
  branch: 'develop',
  date: 'Mon, 19 Oct 2026 11:01:05 GMT'
};